import React, { useState, useEffect } from 'react';
import * as State from '../state';
import { useTranslate } from 'react-translate';

import './like-dislike-activity.css';


const delayBetweenLikes = 10;
const outDuration = 10;
const pathSelected = "M0,342.5C0,304.167 7.16667,268.167 21.5,234.5C35.8333,200.833 55.4167,171.333 80.25,146C105.083,120.667 134.25,100.667 167.75,86C201.25,71.3334 237.333,64.0001 276,64C281,64.0001 287.75,64.2501 296.25,64.75C304.75,65.2501 313.75,66.2501 323.25,67.75C332.75,69.2501 342.417,71.2501 352.25,73.75C362.083,76.2501 371,79.4167 379,83.25C387,87.0834 393.5,91.5834 398.5,96.75C403.5,101.917 406,108 406,115C406,120.333 404.833,125.167 402.5,129.5L313.5,297C311.167,301.333 310,306.333 310,312C310,316.333 310.833,320.583 312.5,324.75C314.167,328.917 316.667,332.5 320,335.5L501,504.5C504.667,507.5 506.5,511.5 506.5,516.5C506.5,520.5 505,526.167 502,533.5C499,540.833 495.167,549 490.5,558C485.833,567 480.833,576.417 475.5,586.25C470.167,596.083 465.167,605.417 460.5,614.25C455.833,623.083 452,631 449,638C446,645 444.5,650.333 444.5,654C444.5,656.333 445.333,658.25 447,659.75C448.667,661.25 450.667,662 453,662C455.333,662 457.333,661 459,659L560.5,534.5C562.833,531.833 564.583,528.667 565.75,525C566.917,521.333 567.5,517.667 567.5,514C567.5,505.667 564.667,498.333 559,492L413.5,340.5C407.5,334.5 404.5,327 404.5,318C404.5,313 405.167,309.167 406.5,306.5C407.833,303.833 409.833,300.667 412.5,297C418.167,289.667 424.083,282.75 430.25,276.25C436.417,269.75 442.5,263.167 448.5,256.5C459.833,243.833 471.083,231.167 482.25,218.5C493.417,205.833 504.833,193.167 516.5,180.5C532.5,163.167 548.833,147.333 565.5,133C582.167,118.667 599.667,106.5 618,96.5C636.333,86.5 655.917,78.75 676.75,73.25C697.583,67.75 720.333,65 745,65C770.667,65 795.417,68.4167 819.25,75.25C843.083,82.0834 865.333,91.5834 886,103.75C906.667,115.917 925.5,130.667 942.5,148C959.5,165.333 974,184.417 986,205.25C998,226.083 1007.33,248.417 1014,272.25C1020.67,296.083 1024,320.833 1024,346.5C1024,383.167 1017.08,418.75 1003.25,453.25C989.417,487.75 969.5,518 943.5,544L544,947.5C535.667,955.833 525.5,960 513.5,960C501.833,960 491.833,955.833 483.5,947.5L81.5,541.5C55.5,515.167 35.4167,484.75 21.25,450.25C7.08333,415.75 0,379.833 0,342.5Z"
const pathUnselected = "M1024,346.5C1024, 383.167 1017.08, 418.75 1003.25, 453.25C989.417, 487.75 969.5, 518 943.5, 544L544, 947.5C535.667, 955.833 525.5, 960 513.5, 960C501.833, 960 491.833, 955.833 483.5, 947.5L81.5, 541.5C55.1667, 514.833 35, 484.333 21, 450C7, 415.667 0, 379.833 0, 342.5C0, 304.167 7.16667, 268.167 21.5, 234.5C35.8333, 200.833 55.4167, 171.333 80.25, 146C105.083, 120.667 134.25, 100.667 167.75, 86C201.25, 71.3334 237.333, 64.0001 276, 64C313.333, 64.0001 348.917, 71.1667 382.75, 85.5C416.583, 99.8334 446.667, 120.167 473, 146.5L511.5, 185.5L549.5, 147C575.5, 121 605.333, 100.917 639, 86.75C672.667, 72.5834 708, 65.5001 745, 65.5C784, 65.5001 820.417, 72.9167 854.25, 87.75C888.083, 102.583 917.583, 122.75 942.75, 148.25C967.917, 173.75 987.75, 203.5 1002.25, 237.5C1016.75, 271.5 1024, 307.833 1024, 346.5ZM960, 346.5C960, 316.833 954.417, 288.833 943.25, 262.5C932.083, 236.167 916.75, 213.167 897.25, 193.5C877.75, 173.833 855, 158.25 829, 146.75C803, 135.25 775, 129.5 745, 129.5C716.667, 129.5 689.583, 134.917 663.75, 145.75C637.917, 156.583 615, 172 595, 192C594, 193 591.417, 195.667 587.25, 200C583.083, 204.333 578.667, 208.833 574, 213.5C569.333, 218.167 565.083, 222.417 561.25, 226.25C557.417, 230.083 555.167, 232.167 554.5, 232.5L554.5, 233L478.5, 319L645.5, 489.5C651.5, 495.5 654.5, 503 654.5, 512C654.5, 520.333 651.667, 527.667 646, 534L536.5, 651.5C529.833, 658.5 522, 662 513, 662C504, 662 496.417, 658.917 490.25, 652.75C484.083, 646.583 481, 639 481, 630C481, 621.667 483.833, 614.333 489.5, 608L578.5, 512.5L412, 342.5C406, 336.5 403, 329 403, 320C403, 315.333 403.583, 311.5 404.75, 308.5C405.917, 305.5 408, 302.333 411, 299L469, 233.5C462, 226.5 455.083, 219.5 448.25, 212.5C441.417, 205.5 434.5, 198.5 427.5, 191.5C407.5, 171.167 384.417, 155.5 358.25, 144.5C332.083, 133.5 304.667, 128 276, 128C246.333, 128 218.583, 133.667 192.75, 145C166.917, 156.333 144.5, 171.667 125.5, 191C106.5, 210.333 91.5, 233.083 80.5, 259.25C69.5, 285.417 64, 313.167 64, 342.5C64, 371.5 69.4167, 399.25 80.25, 425.75C91.0833, 452.25 106.667, 475.833 127, 496.5L513.5, 887L898, 499C918, 479 933.333, 455.667 944, 429C954.667, 402.333 960, 374.833 960, 346.5Z"

export function LikeDislikeActivity(props) {
    const common = useTranslate('Common');
    const t = useTranslate('LikeDislike')
    const [state, setState] = useState(State.init);
    const [selected, setSelected] = useState(null);
    const { callHubAsync, theme } = props;

    useEffect(() => {
        let cancelled = false;
        let onError = (error) => {
            if (!cancelled) {
                console.error(error);
                setState(State.error);
            }
        }
        if (state === State.sending) {
            async function sendAsync() {
                try {
                    const result = await callHubAsync("addLike", { value: selected });
                    if (result) {
                        await new Promise(r => setTimeout(r, outDuration + delayBetweenLikes));

                        if (cancelled) return;
                        setState(State.ready);
                    }
                    else {
                        onError("failed to send like");
                    }
                }
                catch (error) {
                    onError(error);
                }
            }

            sendAsync();

            return () => cancelled = true;

        } else {
            return undefined;
        }
    }, [state, callHubAsync, setState])

    function sendMessage(event) {
        if (selected === event) {
            setSelected(null);
        } else {
            setSelected(event);
        }
        setState(State.sending);
    }

    return (
        <div>
            <div className="likeDislikeWrapper" style={{ marginBottom: '1.5em' }} >
                <svg
                    className="likeDislikeSVG"
                    viewBox="0 0 1024 1024"
                    preserveAspectRatio="xMidYMid meet"
                    onClick={() => sendMessage(true)}
                    fill={selected === true ? theme.lightColor : 'none'}
                    stroke={theme.lightColor}
                    strokeWidth="50"
                >
                    <path d="M0,342.5C0,304.167 7.16667,268.167 21.5,234.5C35.8333,200.833 55.4167,171.333 80.25,146C105.083,120.667 134.25,100.667 167.75,86C201.25,71.3334 237.333,64.0001 276,64C313.667,64.0001 349.25,71.1667 382.75,85.5C416.25,99.8334 446.333,120.167 473,146.5C479.667,153.167 486.083,159.667 492.25,166C498.417,172.333 504.833,178.833 511.5,185.5C517.833,178.833 524.083,172.333 530.25,166C536.417,159.667 542.833,153.333 549.5,147C576.5,121 606.417,100.917 639.25,86.75C672.083,72.5834 707.333,65.5001 745,65.5C783.667,65.5001 820,72.9167 854,87.75C888,102.583 917.583,122.75 942.75,148.25C967.917,173.75 987.75,203.5 1002.25,237.5C1016.75,271.5 1024,307.833 1024,346.5C1024,383.167 1017.08,418.75 1003.25,453.25C989.417,487.75 969.5,518 943.5,544L544,947.5C535.667,955.833 525.5,960 513.5,960C501.833,960 491.833,955.833 483.5,947.5L81.5,541.5C55.5,515.167 35.4167,484.75 21.25,450.25C7.08333,415.75 0,379.833 0,342.5Z">
                    </path>
                </svg>

                <svg
                    className="likeDislikeSVG"
                    viewBox="0 0 1024 1024"
                    preserveAspectRatio="xMidYMid meet"
                    onClick={() => sendMessage(false)}
                    fill={theme.lightColor}
                    stroke={theme.lightColor}
                >
                    <path d={selected === false ? pathSelected : pathUnselected} />
                </svg>
            </div>
            <p><em>{
                selected === null
                ? '\u00A0' // Non-breaking space
                : selected
                   ? t('like')
                   : t('dislike')
            }</em></p>
        </div>
    );
}

    